import React, { useState } from "react";
import cssStyles from "./TMCardItem.module.scss";
import { FormattedMessage } from "react-intl";
import TMCardLinkIcon from "../../../../../../Icons/TMCardLinkIcon";
import { PopupIcon } from "@fluentui/react-northstar";

interface TMCardItemProps {
    image: string;
    title: string;
    description: string;
    link: string;
}

const TMCardItem: React.FC<TMCardItemProps> = ({ image, title, description, link }) => {
    return (
        <a className={cssStyles.card} href={link} target="_blank" rel="noopener noreferrer">
            <div className={cssStyles.imgContainer}>
                <img src={image} alt={title} className={cssStyles.image} />
                <span className={cssStyles.popupIcon}>
                    <PopupIcon outline size="medium" />
                </span>
            </div>
            <div className={cssStyles.textContainer}>
                <div className={cssStyles.headingContainer}>
                    <h3 className={cssStyles.title}>
                        <FormattedMessage
                            id={title}
                            defaultMessage={title}
                        ></FormattedMessage>
                    </h3>
                    <p className={cssStyles.description}>
                        <FormattedMessage
                            id={description}
                            defaultMessage={description}
                        ></FormattedMessage>
                    </p>
                </div>
            </div>
        </a>
    );
};

export default TMCardItem;
